<template>
  <CardContent
    class="chapter-progress"
    theme="neutral-50"
    aspect="square"
    stroke="m"
    elevate="none"
  >
    <template #header>
      <Heading align="left" tag="h4" icon="nomad:course">
        Chapitre en cours
      </Heading>
    </template>
    <div class="content">
      <div class="title">
        <strong>{{ disciplineTitle }}</strong> : {{ chapter.title }}
      </div>
      <ProgressBarLabel
        class="progress-bar"
        theme="secondary"
        :show-label="false"
        :show-quit="false"
        :count="completedExercisesCount"
        :total="totalExercises"
      />
    </div>

    <template #footer><span /></template>
  </CardContent>
</template>
<script setup lang="ts">
const {
  discipline,
  chapter,
  categoryManager: { associatedIds },
} = inject(INJECT_CATEGORY_PAGE);

const disciplineTitle = computed(() =>
  discipline.value ? discipline.value.title : null
);

const progressionExercises = inject(INJECT_PROGRESSION_EXERCISES);

const { completedExercisesCount, totalExercises } =
  useExercisesSummaryProgressions(
    progressionExercises,
    associatedIds.value.exerciseIds
  );
</script>
<style lang="scss" scoped>
.chapter-progress {
  display: none;
  @include desktop {
    display: flex;
  }
}
.title {
  @include font('n', 400, 'secondary');

  color: var(--color_neutral_900);
  strong {
    font-weight: 600;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
}

.progress-bar {
  width: 100%;
}
</style>
